import React from 'react';
import { Link } from 'react-router-dom';

const CourseSuccessPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 flex flex-col items-center justify-center px-4 text-center">
    <div className="bg-white rounded-3xl shadow-lg p-12 max-w-md w-full">
      <div className="text-6xl mb-6">🎉</div>
      <h1 className="text-3xl font-extrabold text-gray-900 mb-3">Payment confirmed!</h1>
      <p className="text-gray-500 mb-8">
        You'll receive an email shortly with access to the course. Check your inbox (and spam folder).
      </p>
      <Link
        to="/"
        className="inline-block px-8 py-3 bg-gradient-to-r from-purple-600 to-pink-500 text-white font-bold rounded-full hover:opacity-90 transition-opacity"
      >
        Back to home
      </Link>
    </div>
  </div>
);

export default CourseSuccessPage;
